"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var AuthService = /** @class */ (function () {
    function AuthService($rootScope, $state, $cookies, UserService, store, AUTH_EVENTS, $q, APPURL, $http, SITEURL, VueStoreFactory) {
        this.AUTH_TOKEN_KEY = 'dc-auth-token';
        this.EXPIRATION_KEY = 'dc-token-expiration-date';
        var domain = SITEURL.replace('http://', '.')
            .replace('https://', '.')
            .replace('app.', '');
        this.cookieConfig = { path: '/', domain: domain };
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$state = $state;
        this.$cookies = $cookies;
        this.UserService = UserService;
        this.$q = $q;
        this.store = store;
        this.user = UserService.getCurrentUser();
        this.AUTH_EVENTS = AUTH_EVENTS;
        this.APPURL = APPURL;
        this.SITEURL = SITEURL;
        this.VueStoreFactory = VueStoreFactory;
        this.transformUser = this.transformUser.bind(this);
    }
    /////////////////////////
    AuthService.prototype.logout = function () {
        var _this = this;
        return this.$http.post(this.APPURL + '/logout', {}).then(function (response) {
            _this.VueStoreFactory.dispatch('LOGOUT');
            return response.data;
        });
    };
    AuthService.prototype.remindPassword = function (username) {
        return this.$http
            .post(this.APPURL + '/api/v1/remindPassword', { username: username })
            .then(function (response) {
            return response.data;
        });
    };
    AuthService.prototype.resetPassword = function (data) {
        return this.$http
            .post(this.APPURL + '/api/v1/resetPassword', {
            username: data.username,
            token: data.token,
            password: data.password,
            password_confirmation: data.password_confirmation,
        })
            .then(function (response) {
            return response.data;
        });
    };
    AuthService.prototype.submitCredentials = function (credentials) {
        var authRequest = {
            method: 'POST',
            url: "".concat(this.APPURL, "/auth"),
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            data: {
                username: credentials.email,
                password: credentials.password,
            },
        };
        return this.$http(authRequest);
    };
    AuthService.prototype.transformUser = function (response) {
        this.setToken(response.data.access_token);
        this.setTokenExpiration(response.data.expires_in);
        var user = Object.assign({}, response.data.user, {
            access_token: response.data.access_token,
        });
        this.UserService.setCurrentUser(user);
        this.$rootScope.$broadcast(this.AUTH_EVENTS.loginSuccess);
        return user;
    };
    AuthService.prototype.getCurrentUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var deferred, token, request, response, Error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        deferred = this.$q.defer();
                        token = this.getToken();
                        request = {
                            method: 'GET',
                            url: this.APPURL + '/api/v1/user',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                Authorization: 'Bearer ' + token,
                            },
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$http(request)];
                    case 2:
                        response = _a.sent();
                        // @ts-ignore
                        deferred.resolve(response.data.user);
                        // @ts-ignore
                        return [2 /*return*/, deferred.promise];
                    case 3:
                        Error_1 = _a.sent();
                        deferred.reject(Error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AuthService.prototype.login = function (credentials) {
        return __awaiter(this, void 0, void 0, function () {
            var response, Error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.removeToken();
                        return [4 /*yield*/, this.submitCredentials(credentials)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.transformUser(response)];
                    case 2:
                        Error_2 = _a.sent();
                        this.$rootScope.$broadcast(this.AUTH_EVENTS.loginFailed);
                        throw Error_2(Error_2.data.detail);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthService.prototype.manualLogin = function (user) {
        this.setToken(user.access_token);
        this.UserService.setCurrentUser(user);
        // $rootScope.$broadcast(AUTH_EVENTS.loginSuccess);
        //Session.create(res.data.id, res.data.user.id, res.data.user.role);
        return user;
    };
    AuthService.prototype.setTokenExpiration = function (expiresIn) {
        if (expiresIn) {
            var date = new Date();
            var expiryDate = date.getTime() + expiresIn * 1000;
            this.store.set(this.EXPIRATION_KEY, new Date(expiryDate));
        }
        else {
            this.store.remove(this.EXPIRATION_KEY);
        }
    };
    AuthService.prototype.getToken = function () {
        // If the auth token is in the cookie, get it and store it in local storage
        if (this.$cookies.get(this.AUTH_TOKEN_KEY)) {
            var token = this.$cookies
                .get(this.AUTH_TOKEN_KEY)
                .replace(/^'|'$/g, '');
            this.setToken(token);
            this.VueStoreFactory.dispatch('SET_TOKEN', token);
            // remove the cokies
            this.$cookies.remove(this.AUTH_TOKEN_KEY, this.cookieConfig);
            this.$cookies.remove('dc-user', this.cookieConfig);
        }
        return this.store.get(this.AUTH_TOKEN_KEY);
    };
    AuthService.prototype.goToLogin = function () {
        this.$state.go('drivecoach.login');
    };
    AuthService.prototype.removeToken = function () {
        this.store.remove(this.AUTH_TOKEN_KEY);
        this.store.remove('ds-token');
        this.store.remove('ds-user');
        this.$cookies.remove(this.AUTH_TOKEN_KEY, this.cookieConfig);
        this.$cookies.remove('ds-user', this.cookieConfig);
    };
    AuthService.prototype.setToken = function (token) {
        if (token) {
            this.store.set(this.AUTH_TOKEN_KEY, token);
            this.VueStoreFactory.dispatch('SET_TOKEN', token);
        }
        else {
            this.removeToken();
            this.VueStoreFactory.dispatch('SET_TOKEN', null);
        }
    };
    /**
     * This returns true when a user's token is successfuly retreived. Returns
     * false if the token cannot be found in a cookie or local storage
     */
    AuthService.prototype.isAuthenticated = function () {
        var token = this.getToken();
        if (!token) {
            return false;
        }
        return true;
    };
    AuthService.prototype.isAuthorized = function (authorizedRoles) {
        return __awaiter(this, void 0, void 0, function () {
            var deferred, user, Error_3, isAuthorizedOrSuperAdmin;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        deferred = this.$q.defer();
                        if (this.isAuthenticated() === false) {
                            return [2 /*return*/, false];
                        }
                        user = this.UserService.getCurrentUser();
                        if (!!user) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getCurrentUser()];
                    case 2:
                        user = _a.sent();
                        this.UserService.setCurrentUser(user);
                        return [3 /*break*/, 4];
                    case 3:
                        Error_3 = _a.sent();
                        deferred.reject(Error_3);
                        return [3 /*break*/, 4];
                    case 4:
                        user = this.UserService.getCurrentUser();
                        if (!angular_1.default.isArray(authorizedRoles)) {
                            authorizedRoles = [authorizedRoles];
                        }
                        isAuthorizedOrSuperAdmin = authorizedRoles.indexOf(user.role.type) !== -1 ||
                            user.role.type === 'super_admin';
                        deferred.resolve(this.isAuthenticated() && isAuthorizedOrSuperAdmin);
                        return [2 /*return*/, deferred.promise];
                }
            });
        });
    };
    AuthService.prototype.addQueryParams = function (params) {
        this.queryParams = params;
    };
    AuthService.prototype.getQueryParams = function () {
        if (typeof this.queryParams === 'undefined') {
            var params = window.location.toString().split('?');
            if (params.length === 2) {
                this.addQueryParams(params[1]);
                return params[1].toString();
            }
            return '';
        }
        return this.queryParams.toString();
    };
    return AuthService;
}());
AuthService.$inject = [
    '$rootScope',
    '$state',
    '$cookies',
    'UserService',
    'store',
    'AUTH_EVENTS',
    '$q',
    'APPURL',
    '$http',
    'SITEURL',
    'VueStoreFactory',
];
exports.default = AuthService;
